import React from 'react'

import { TableContainer } from 'shared/StyledComponents'
import LKGrid from 'shared/LKGrid'
import LKModal from 'shared/LKModal'

import translate from '../../../translator'
import config from './DLConfig'

import container from './container'

@container
class Tags extends React.Component {
  getContextMenuItems = ({
    node: {
      data: { ID, TagID },
    },
  }) => [
    {
      name: translate('cmd_delete_tag'),
      icon: 'delete',
      action: () => this.props.openConfirmation(ID, TagID),
      permissionKey: 'LOAN_DEL_TAG',
    },
  ]

  render() {
    return (
      <TableContainer>
        <LKModal.Confirmation
          name="LoanDetailsDeleteTag"
          onConfirm={this.props.deleteTag}
          loading={this.props.loading}
        />

        <LKGrid
          instanceName={this.props.instanceName}
          rowData={this.props.data}
          getContextMenuItems={this.getContextMenuItems}
          {...config}
        />
      </TableContainer>
    )
  }
}

export default Tags
